import React, { useContext } from 'react';

import { LocaleContext } from 'app/containers/LocaleProvider';

import DishCardUpsell from 'app/components/DishCardUpsell';
import Responsive from 'app/components/Responsive';

import { useButtonOptimisticState } from '../useButtonOptimisticState';
import { DishCardUpsellDesktop } from '../DishCardUpsell';

import { roundPrice } from '../roundPrice';


export function DishLayoutUpsell(props) {
    const {
        imageUrl,
        imageUrlDesktop,
        id,
        dishCountStep,
        price,
        portion,

        title,
        trackAddToBasket,
    } = props;

    const { locale } = useContext(LocaleContext);

    const { isDishInBasket, handleAddToBasket } = useButtonOptimisticState(
        id,
        portion,
        dishCountStep,
        trackAddToBasket,
    );

    const priceWithPortions = roundPrice(price * dishCountStep);

    const joinedTitle = title.join(' ');

    return (
        <Responsive
            isWideMobile
            mobile={(
                <DishCardUpsell
                    previewMobileImage={imageUrl}
                    title={joinedTitle}
                    titleEn={joinedTitle}
                    caption=""
                    captionEn=""
                    dishPrice={priceWithPortions}
                    onClick={handleAddToBasket}
                    loading={false}
                    locale={locale}
                    id={id}
                    isDishInBasket={isDishInBasket}
                />
            )}
            desktop={(
                <DishCardUpsellDesktop
                    imageUrl={imageUrl}
                    imageUrlDesktop={imageUrlDesktop}
                    price={priceWithPortions}
                    portion={portion}
                    title={title}
                    handleAddToBasket={handleAddToBasket}
                    isDishInBasket={isDishInBasket}
                />
            )}
        />
    );
}
